import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  GET_ALL_DEPARTMENTAL_MONEY_COUNT,
  GET_ALL_DEPARTMENTAL_MONEY_COUNT_DATA,
  GET_ALL_DEPARTMENTAL_MONEY_PENDING,
  GET_ALL_DEPARTMENTAL_PROCESS_APPROVED,
  /******************* USER COUNT **********************/
  GET_ALL_USER_WALLET_MONEY_COUNT,
  GET_ALL_USER_MONEY_PENDING,
  GET_ALL_USER_PROCESS_APPROVED,
  GET_ALL_USER_REFERRALS,
  GET_ALL_TRANSFER_MONEY,
  GET_ALL_TRANSFER_MONEY_PROCESS,
} from "../../types";
import { setErrors } from "../errorActions";
import { errorAlert } from "../../../function/alert";

/*******************************************
 * @DESC GET DEPARTMENTAL WALLET MONEY ACTION
 ******************************************/
export const get_all_departmental_money = (token, code) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    const getAllDepartmentalMoney = await axios.get(
      `${serverApi}/admin/wallet?departmentalWallet=${code}`,
      {
        headers: { Authorization: token, "Content-Type": "application/json" },
      }
    );
    if (getAllDepartmentalMoney.status === 200) {
      dispatch({
        type: GET_ALL_DEPARTMENTAL_MONEY_COUNT,
        payload: getAllDepartmentalMoney.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const get_all_departmental_money_data =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllDepartmentalMoneyData = await axios.get(
        `${serverApi}/admin/wallet?admin_transaction=true&payment_captured=true&status=PROCESSED&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllDepartmentalMoneyData.status === 200) {
        dispatch({
          type: GET_ALL_DEPARTMENTAL_MONEY_COUNT_DATA,
          payload: getAllDepartmentalMoneyData.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*******************************************
 * @DESC GET DEPARTMENTAL PENDING APPROVED REJECTED WALLET ACTION
 ******************************************/
export const get_all_departmental_pending_data =
  (token, actionBy, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    dispatch({
      type: GET_ALL_DEPARTMENTAL_MONEY_PENDING,
      payload: [],
    });
    try {
      const getAllDepartmentalPending = await axios.get(
        `${serverApi}/admin/wallet?admin_transaction=true&status=${actionBy}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllDepartmentalPending.status === 200) {
        dispatch({
          type: GET_ALL_DEPARTMENTAL_MONEY_PENDING,
          payload: getAllDepartmentalPending.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*******************************************
 * @DESC UPDATED API FOR REJECTED WALLET REQUEST
 ******************************************/
export const update_api_for_rejected_approved_action =
  (token, formData, id, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let response = await axios.patch(
        `${serverApi}/admin/wallet/${id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*******************************************
 * @DESC ADD MONEY TO DEPARTMENTAL WALLET ACTION
 ******************************************/
export const admin_add_money_departmental_wallet =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.post(`${serverApi}/admin/wallet`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err?.response?.data?.message));
    }
  };

/***************************************************
 * @DESC GET PROCESS APPROVED DEPARTMENTAL WALLET
 **************************************************/
export const get_process_approved_departmental_wallet =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllProcessedDepartmentsWallet = await axios.get(
        `${serverApi}/admin/wallet?admin_transaction=true&status=APPROVED&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllProcessedDepartmentsWallet.status === 200) {
        dispatch({
          type: GET_ALL_DEPARTMENTAL_PROCESS_APPROVED,
          payload: getAllProcessedDepartmentsWallet.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/**************************************************************************
 * @DESC USER WALLET TRANCTIONS ALL ACTION
 **************************************************************************/
/*******************************************
 * @DESC ADD MONEY TO USER WALLET ACTION
 ******************************************/
export const admin_add_money_user_wallet =
  (token, formData, onSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.post(`${serverApi}/admin/wallet`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };

/*******************************************
 * @DESC GET USER WALLET MONEY ACTION
 ******************************************/
export const get_all_user_money_data =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllUserMoney = await axios.get(
        `${serverApi}/admin/wallet?admin_transaction=false&payment_captured=true&status=PROCESSED&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllUserMoney.status === 200) {
        dispatch({
          type: GET_ALL_USER_WALLET_MONEY_COUNT,
          payload: getAllUserMoney.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***********************************************************
 * @DESC GET USER WALLET PENDING APPROVED REJECTED ACTION
 **********************************************************/
export const get_all_userwallet_pending_data =
  (token, actionBy, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    dispatch({
      type: GET_ALL_USER_MONEY_PENDING,
      payload: [],
    });
    try {
      const getAllUserPending = await axios.get(
        `${serverApi}/admin/wallet?admin_transaction=false&status=${actionBy}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllUserPending.status === 200) {
        dispatch({
          type: GET_ALL_USER_MONEY_PENDING,
          payload: getAllUserPending.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*****************************************************
 * @DESC UPDATED API FOR REJECTED USER WALLET REQUEST
 *****************************************************/
export const update_user_wallet_api_rejected_approved =
  (token, formData, id, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let response = await axios.patch(
        `${serverApi}/admin/wallet/${id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        errorAlert(err.response?.data?.message)
      }
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************************
 * @DESC GET PROCESS APPROVED USERS WALLET
 **************************************************/
export const get_process_approved_user_wallet =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllProcessedUsersWallet = await axios.get(
        `${serverApi}/admin/wallet?admin_transaction=false&status=APPROVED&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllProcessedUsersWallet.status === 200) {
        dispatch({
          type: GET_ALL_USER_PROCESS_APPROVED,
          payload: getAllProcessedUsersWallet.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************************
 * @DESC GET ALL USERS REFEERALS WALLET
 **************************************************/
export const get_all_user_refeerals_wallet =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllUserRefeeralsWallet = await axios.get(
        `${serverApi}/admin/transfer-money&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllUserRefeeralsWallet.status === 200) {
        dispatch({
          type: GET_ALL_USER_REFERRALS,
          payload: getAllUserRefeeralsWallet.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************************
 * @DESC GET USER TRANSFER MONEY WALLET
 **************************************************/
export const get_all_user_transfer_money =
  (token, actionBy, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllUserTransferMoney = await axios.get(
        `${serverApi}/admin/transfer-money?transcation_status=${actionBy}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllUserTransferMoney.status === 200) {
        dispatch({
          type: GET_ALL_TRANSFER_MONEY,
          payload: getAllUserTransferMoney.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************************************
 * @DESC UPDATED API FOR TRANSFER MONEY UDBHAV AND USER WALLET
 **************************************************************/
export const update_api_transfer_money_wallet =
  (token, formData, onSuccess, onErrorSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let response = await axios.post(
        `${serverApi}/admin/transfer-money`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorSuccess(err);
    }
  };

/***************************************************************
 * @DESC UPDATED API FOR REJECT AND APPROVED WALLET
 **************************************************************/
export const update_api_reject_approved_transfer_money =
  (token, formData, id, onSuccess, onErrorSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let response = await axios.patch(
        `${serverApi}/admin/transfer-money/${id}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorSuccess(err);
    }
  };

/***************************************************
 * @DESC GET PROCESS APPROVED USERS TRANSFER MONEY WALLET
 **************************************************/
export const get_process_approved_user_trasfer_money =
  (token, startDate, endDate) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      const getAllProcessedUsersTransferMoney = await axios.get(
        `${serverApi}/admin/transfer-money?transcation_status=APPROVED&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: { Authorization: token, "Content-Type": "application/json" },
        }
      );
      if (getAllProcessedUsersTransferMoney.status === 200) {
        dispatch({
          type: GET_ALL_TRANSFER_MONEY_PROCESS,
          payload: getAllProcessedUsersTransferMoney.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
